import { useMemo } from 'react';
import type { KdsTicket } from '../types';
import type { ViewMode } from '../components/ViewSwitcher';
import { aggregateForChef } from '../utils/aggregation';

export function useChefView(tickets: KdsTicket[]) {
  const dishes = useMemo(() => aggregateForChef(tickets), [tickets]);

  const pendingCount = useMemo(
    () =>
      tickets.reduce(
        (sum, t) =>
          sum +
          t.items
            .filter((i) => i.status === 'Pending' || i.status === 'InProgress')
            .reduce((s, i) => s + (i.total_quantity - i.done_quantity), 0),
        0,
      ),
    [tickets],
  );

  // Auto-adaptive: count active tickets (not ready)
  const activeTicketCount = tickets.filter((t) => !t.is_ready).length;

  const recommendedView: ViewMode = useMemo(() => {
    if (activeTicketCount < 5) return 'table-flow';
    return 'aggregated';
  }, [activeTicketCount]);

  const compactMode = activeTicketCount > 15;

  return { dishes, pendingCount, activeTicketCount, recommendedView, compactMode };
}
